import { FieldType } from '@wix/wix-data-schema-types'
import { isPageLinkStale } from '@wix/wix-data-client-common-standalone'
import {
  deleteFieldPermanently,
  updateSchema,
} from '@wix/wix-code-collections-api'
import type {
  EditorSDK,
  Logger,
  RouterConfig,
} from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
const { pageLink } = FieldType

export const removeStalePagelinks = async ({
  editorSdkProxy,
  collectionsApi,
  logger,
}: {
  editorSdkProxy: EditorSDK
  collectionsApi: CollectionsApi
  logger: Logger
}) => {
  const [routers = [], collections] = await Promise.all([
    editorSdkProxy.routers.getAll<RouterConfig>(),
    collectionsApi.getAll(),
  ])

  collections.forEach(async collection => {
    const stalePagelinkKeys = Object.entries(collection.fields)
      .filter(
        ([_fieldKey, field]) =>
          field.type === pageLink && isPageLinkStale(field, routers),
      )
      .map(([fieldKey]) => fieldKey)

    if (stalePagelinkKeys.length !== 0) {
      const patches = stalePagelinkKeys.map(fieldKey =>
        deleteFieldPermanently(fieldKey),
      )

      collectionsApi
        .execute(updateSchema(collection.id, ...patches))
        .catch(error =>
          logger.error(
            new Error(
              `Failed to delete stale pagelinks from ${collection.id} collection.`,
              { cause: error },
            ),
          ),
        )
    }
  })
}
